import React from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './style.scss';

import { language, swalText } from "../../../../Constants";

import Helpers from "../../../../libs/helpers";


const Portfolio = ({ portfolio2id, change, delP2, data}) => {
    const arm = data[2];

    return (
        <div className="portfolio" id={`p2-${portfolio2id}`}>
            <div className='left'>
                <div className='header'><span><b>Անուն։ </b></span>{arm.title}</div>
                <div className='desc'><span><b>Նկարագրություն։ </b></span>{arm.text}</div>
                {arm.feedback && <div className='desc'><span><b>Արձագանք։ </b></span>{arm.feedback}</div>}
                {arm.feedback2 && <div className='desc'><span><b>Երկրորդ արձագանք։ </b></span>{arm.feedback2}</div>}
            </div>
            <div className='right'>
                <span title='Ջնջել ծառայությունը' onClick={del(portfolio2id, delP2)}><FontAwesomeIcon icon='ban'/></span>
                <span title='Կատարել փոփոխություններ' onClick={upd({data, change, id: portfolio2id})}><FontAwesomeIcon
                    icon='wrench'/></span>
                <span title='Տեսնել ավելին' onClick={showMore(data)}><FontAwesomeIcon icon='info'/></span>
            </div>
        </div>
    )
};

function upd({data, change, id}) {
    return function () {
        Swal.fire({
            type: 'question',
            title: swalText.change,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true,
            html: `
                <div id='p2InfoTag'>
                   <section>
                        <div><b>${language[0].title}<span class="red">*</span> </b><input type="text" value="${data[0].title}" required min='3'></div>
                        <div><b>${language[1].title}<span class="red">*</span> </b><input type="text" value="${data[1].title}" required min='3'></div>
                        <div><b>${language[2].title}<span class="red">*</span> </b><input type="text" value="${data[2].title}" required min='3'></div>
                    </section>
                    <section>
                        <div><b>${language[0].description}<span class="red">*</span> </b><textarea required>${data[0].text}</textarea></div>
                        <div><b>${language[1].description}<span class="red">*</span> </b><textarea required>${data[1].text}</textarea></div>
                        <div><b>${language[2].description}<span class="red">*</span> </b><textarea required>${data[2].text}</textarea></div>
                    </section>
                    <section>
                        <div><b>${language[0].feedback} </b><textarea>${data[0].feedback}</textarea></div>
                        <div><b>${language[1].feedback} </b><textarea>${data[1].feedback}</textarea></div>
                        <div><b>${language[2].feedback} </b><textarea>${data[2].feedback}</textarea></div>
                    </section>
                    <section>
                        <div><b>${language[0].feedback2} </b><textarea>${data[0].feedback2}</textarea></div>
                        <div><b>${language[1].feedback2} </b><textarea>${data[1].feedback2}</textarea></div>
                        <div><b>${language[2].feedback2} </b><textarea>${data[2].feedback2}</textarea></div>
                    </section>
                </div>
            `
        }).then(result => {
            if (result.value) {
                let tag = document.querySelectorAll('#p2InfoTag input, #p2InfoTag  textarea');
                let info = [].map.call(tag, el => el.value.trim());
                let errors = Helpers.checkErrors(info.slice(0,6));
                if (errors.length) {
                    Swal.fire({
                        type: 'error',
                        title: 'Կիսատ ինֆորմացիա',
                        text: 'Լրացրեք բոլոր աստղանիշերով դաշտերը'
                    });
                    return;
                }
                axios.post('/api/portfolio2/upd', {info, id}).then(result => {
                    if (result.data.message === 'Updates completed') {
                        let newP2 = {
                            id,
                            data: []
                        };
                        ['en', 'ru', 'arm'].map((el, index) => {
                            newP2.data.push({
                                language: el,
                                title: info[index],
                                text: info[index + 3],
                                feedback: info[index + 6],
                                feedback2: info[index + 9]
                            })
                        });
                        change(newP2);
                    }
                })
            }
        })
    }
}

function showMore(data) {
    const feedback = data[0].feedback && `
        <section>
            <div><b>${language[0].feedback}: </b>${data[0].feedback}</div>
            <div><b>${language[1].feedback}: </b>${data[1].feedback}</div>
            <div><b>${language[2].feedback}: </b>${data[2].feedback}</div>
        </section>
    `;
    const feedback2 = data[0].feedback && `
        <section>
            <div><b>${language[0].feedback2}: </b>${data[0].feedback2}</div>
            <div><b>${language[1].feedback2}: </b>${data[1].feedback2}</div>
            <div><b>${language[2].feedback2}: </b>${data[2].feedback2}</div>
        </section>
    `;
    return function () {
        Swal.fire({
            type: 'info',
            confirmButtonText: swalText.ok,
            showCloseButton: true,
            html: `
                <div id='bimInfoTag'>
                   <section>
                        <div><b>${language[0].title}: </b>${data[0].title}</div>
                        <div><b>${language[1].title}: </b>${data[1].title}</div>
                        <div><b>${language[2].title}: </b>${data[2].title}</div>

                    </section>
                    <section>
                        <div><b>${language[0].description}: </b>${data[0].text}</div>
                        <div><b>${language[1].description}: </b>${data[1].text}</div>
                        <div><b>${language[2].description}: </b>${data[2].text}</div>
                    </section>
                    ${feedback || ''}
                    ${feedback2 || ''}
                </div>
            `
        })
    }
}

function del(id, delP2) {
    return function(){
        Swal.fire({
            type: 'question',
            title: swalText.del,
            text: swalText.delMore,
            confirmButtonText: swalText.yes,
            cancelButtonText: swalText.cancel,
            showCloseButton: true,
            showCancelButton: true
        }).then(result => {
            if (result.value) {
                axios.delete(`/api/portfolio2/delById/${id}`).then(result => {
                    if (result.data.message === 'portfolio deleted') delP2(id);;
                })
            }
        })
    }
}

export default Portfolio;